import { render, staticRenderFns } from "./EegChart.vue?vue&type=template&id=059badfe&"
import script from "./EegChart.vue?vue&type=script&lang=ts&"
export * from "./EegChart.vue?vue&type=script&lang=ts&"
import style0 from "./EegChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports